export default "__VITE_ASSET__2LglSxXN__"